<template>
  <el-card>
    <div slot="header">
      Tagok
    </div>
    <h4>Bizottsági tagok</h4>
    <el-form
      :key="formKey"
      class="member-form"
    >
      <el-table
        :data="committeeMembers"
        style="width: 100%"
        border
      >
        <el-table-column
          prop="user"
          label="Név"
        >
          <template slot-scope="scope">
            <el-form-item
              :error="formErrors['committeeUserSelect' + scope.$index] || ''"
            >
              <el-select
                v-model="committeeMembers[scope.$index].user"
                :ref="'committeeMemberName_' + scope.$index"
                style="width: 100%;"
                filterable
                value-key="id"
                :disabled="dialogType === 'view'"
                @change="validateField(committeeMembers[scope.$index].user, 'committeeUserSelect', scope.$index) "
              >
                <el-option
                  v-for="user in users"
                  v-show="!isUserSelected(user, 'committee')"
                  :key="user.id"
                  :label="`${user.last_name} ${user.first_name} (@${user.username})`"
                  :value="user"
                />
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
          prop="position"
          label="Pozíció"
        >
          <template slot-scope="scope">
            <el-form-item
              :error="formErrors['committeePositionSelect' + scope.$index] || ''"
            >
              <el-select
                v-model="committeeMembers[scope.$index].position"
                style="width: 100%;"
                :disabled="dialogType === 'view'"
                @change="validateField(committeeMembers[scope.$index].position, 'committeePositionSelect', scope.$index)"
              >
                <el-option
                  label="Vezető"
                  value="leader">Vezető
                </el-option>
                <el-option
                  label="Tag"
                  value="member">Tag
                </el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
          width="70"
        >
          <template slot-scope="scope">
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              :disabled="dialogType === 'view'"
              @click="deleteCommitteeMember(scope.$index)"
              class="stock-taking-member-delete-button"
            />
          </template>
        </el-table-column>
      </el-table>
      <div
        class="add-item"
      >
        <el-button
          icon="el-icon-plus"
          size="mini"
          :disabled="dialogType === 'view'"
          @click="addCommitteeMember"
        >
          Tag hozzáadása
        </el-button>
      </div>
      <h4>Leltározók</h4>
      <el-table
        :data="stockTakingMembers"
        style="width: 100%"
        border
      >
        <el-table-column
          prop="user"
          label="Név"
        >
          <template slot-scope="scope">
            <el-form-item
              :error="formErrors['stockTakingUserSelect' + scope.$index] || ''"
            >
              <el-select
                v-model="stockTakingMembers[scope.$index].user"
                style="width: 100%;"
                :ref="'stockTakingMemberName_' + scope.$index"
                filterable
                value-key="id"
                :disabled="dialogType === 'view'"
                @change="validateField(stockTakingMembers[scope.$index].user, 'stockTakingUserSelect', scope.$index)"
              >
                <el-option
                  v-for="user in users"
                  v-show="!isUserSelected(user, 'stockTaking')"
                  :key="user.id"
                  :label="`${user.last_name} ${user.first_name} (@${user.username})`"
                  :value="user"
                />
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
          prop="position"
          label="Pozíció"
        >
          <template slot-scope="scope">
            <el-form-item
              :error="formErrors['stockTakingPositionSelect' + scope.$index] || ''"
            >
              <el-select
                v-model="stockTakingMembers[scope.$index].position"
                style="width: 100%;"
                :disabled="dialogType === 'view'"
                @change="validateField(stockTakingMembers[scope.$index].user, 'stockTakingPositionSelect', scope.$index)"
              >
                <el-option
                  label="Vezető"
                  value="leader">Vezető
                </el-option>
                <el-option
                  label="Tag"
                  value="member">Tag
                </el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
          width="70"
        >
          <template slot-scope="scope">
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              :disabled="dialogType === 'view'"
              @click="deleteStockTakingMember(scope.$index)"
              class="stock-taking-member-delete-button"
            />
          </template>
        </el-table-column>
      </el-table>
      <div
        class="add-item"
      >
        <el-button
          icon="el-icon-plus"
          size="mini"
          :disabled="dialogType === 'view'"
          @click="addStockTakingMember"
        >
          Tag hozzáadása
        </el-button>
      </div>
    </el-form>
  </el-card>
</template>
<script>
  export default {
    props: ['members', 'dialogType'],
    data() {
      return {
        committeeMembers: [],
        stockTakingMembers: [],
        formErrors: {},
        formKey: 0
      };
    },
    computed: {
      users() {
        return this.$store.getters['user/users'];
      }
    },
    watch: {
      members(newVal) {
        this.committeeMembers = newVal && newVal.length && newVal.filter(member => member.type === 'committee') || [];
        this.stockTakingMembers = newVal && newVal.length && newVal.filter(member => member.type === 'stock-taking') || [];
      }
    },
    mounted() {
      this.committeeMembers = this.members && this.members.length && this.members.filter(member => member.type === 'committee') || [];
      this.stockTakingMembers = this.members && this.members.length && this.members.filter(member => member.type === 'stock-taking') || [];
    },

    methods: {
      addCommitteeMember() {
        this.committeeMembers.push({
          type: 'committee'
        });

        this.$nextTick(() => {
          this.$refs['committeeMemberName_' + (this.committeeMembers.length-1)].focus();
        });

        this.resetFields();
      },

      addStockTakingMember() {
        this.stockTakingMembers.push({
          type: 'stock-taking'
        });

        this.$nextTick(() => {
          this.$refs['stockTakingMemberName_' + (this.stockTakingMembers.length - 1)].focus();
        });

        this.resetFields();
      },
      deleteCommitteeMember(index) {
        this.committeeMembers.splice(index, 1);
        this.resetFields();
      },
      deleteStockTakingMember(index) {
        this.stockTakingMembers.splice(index, 1);
        this.resetFields();
      },
      isAllFormFieldValid() {
        let isAllfieldsValid = true;
        this.committeeMembers.forEach((member,index) => {
          if(!member.user || member.user === '') {
            this.formErrors['committeeUserSelect' + index] = 'Mező kitöltese kötelező';
            this.formKey++;
            isAllfieldsValid = false;
          }
          if(!member.position || member.position === '') {
            this.formErrors['committeePositionSelect' + index] = 'Mező kitöltese kötelező';
            this.formKey++;
            isAllfieldsValid = false;
          }
        });
        this.stockTakingMembers.forEach((member,index) => {
          if(!member.user || member.user === '') {
            this.formErrors['stockTakingUserSelect' + index] = 'Mező kitöltese kötelező';
            this.formKey++;
            isAllfieldsValid = false;
          }
          if(!member.position || member.position === '') {
            this.formErrors['stockTakingPositionSelect' + index] = 'Mező kitöltese kötelező';
            this.formKey++;
            isAllfieldsValid = false;
          }
        });
        return isAllfieldsValid;
      },
      validateField(value, field, index) {
        if(!value || value === '') {
          this.formErrors[field + index] = 'Mező kitöltese kötelező';
        } else
          this.formErrors[field + index] = '';
      },
      resetFields() {
        this.formErrors = {};
      },
      isUserSelected(user, type) {
        switch(type) {
          case 'stockTaking':
            return this.stockTakingMembers.find(member => member.user && member.user.id === user.id) ? true : false;
          case 'committee':
            return this.committeeMembers.find(member => member.user && member.user.id === user.id) ? true : false;
          default:
            return false;
        }
      }
    }
  };
</script>
<style scoped>
  .add-item {
    border-bottom: 1px dotted #dadfe7;
    border-left: 1px dotted #dadfe7;
    border-right: 1px dotted #dadfe7;
    text-align: center;
    padding: 10px;
  }
  .member-form .stock-taking-member-delete-button {
    margin-bottom: 22px;
  }
</style>
